export enum GiftSource {
  NEWS = 'news'
}
